import firebase from 'firebase';



var firebaseConfig = {
    apiKey: 'AIzaSyBOBpZVCB6TWaUeH9hH_rBberKawF7hiow',
    authDomain: 'callcentral-5a55b.firebaseapp.com',
    databaseURL: 'https://callcentral-5a55b.firebaseio.com',
    projectId: 'callcentral-5a55b',
    storageBucket: 'callcentral-5a55b.appspot.com',
    messagingSenderId: '195742491303',
    appId: "1:195742491303:android:8e30023b12d2a3fd"
  };
 
 
firebase.initializeApp(firebaseConfig);


  export default firebase